<template>
  <div class="wt2-radio-circle" :class="{ '-disabled': disabled }">
    <slot name="header"></slot>
    <div class="-radio-circle-box">
      <div
        class="-radio-buttons"
        :class="{ '-only-one-button': normalizeButtons.length === 1 }"
      >
        <div
          class="-button"
          v-for="button in normalizeButtons"
          :key="button.value"
        >
          <wt-button
            type="transparent"
            class="-custom -min-width-unset"
            :icon="button.icon"
            :disabled="disabled"
            :text="!button.icon ? button.text : ''"
            :class="{
              '-active': !disabled && button.value === curValue,
            }"
            @click="updateValue(button.value)"
          ></wt-button>
          <span v-if="button.icon">{{ button.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import radioMixin from './mixins/radioMixin.vue';

export default {
  mixins: [radioMixin],

  computed: {},
};
</script>
